let loadPromise: Promise<void> | null = null;

export function loadTradingViewLibrary(): Promise<void> {
  if (typeof TradingView !== 'undefined') return Promise.resolve();
  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = '/charting_library/charting_library.standalone.js';
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load TradingView charting library'));
    document.head.appendChild(script);
  });

  return loadPromise;
}
